import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ILabSpecialty, ILabSpecialtyList } from "app/models/core/lab/specialty";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";


@Component({
  selector: 'app-specialty',
  templateUrl: './specialty.component.html'

})

export class SpecialtyComponent implements OnInit {
  @Input() stateNumber: string = '';

  list: ILabSpecialty[] = [];
  specialties: ILabSpecialtyList[] = [];
  saveValue: ILabSpecialty;
  displayedColumns: string[] = ['majorCat', 't_CD', 'code',
    'pt', 'volume', 'dateOpened', 'dateClosed', 'createdBy', 'specialtyId'
  ];

  dataSource = new MatTableDataSource<ILabSpecialty>(this.list);

  listFilter = '';
  editMode = 'list';

  specialtyFormGroup = new UntypedFormGroup({
    MajorCat: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
    Code: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
    T_cd: new UntypedFormControl('', [Validators.maxLength(5)]),
    Pt: new UntypedFormControl('', [Validators.maxLength(1)]),
    Volume: new UntypedFormControl(0,),
    DateOpened: new UntypedFormControl(new Date(),[Validators.required]),
    DateClosed: new UntypedFormControl(new Date(),),
    CreatedBy: new UntypedFormControl('', [Validators.maxLength(50)]),
    Comments: new UntypedFormControl('', [Validators.maxLength(80)]),
    LabId: new UntypedFormControl(0,),
    DateUpdated: new UntypedFormControl('',),
    UpdatedBy: new UntypedFormControl('', [Validators.maxLength(50)]),
    SpecialtyId: new UntypedFormControl(0,)
  });

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public labService: LabService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit() {
    if (this.stateNumber != '') {
      this.loadLabSpecialties();
      this.loadSpecialtiesList();
    }
    this.editMode = 'list';
  }

  loadLabSpecialties() {
    this.labService.getLabSpecialtyList(this.stateNumber).subscribe(
      res => {
        this.list = res;
        this.calculateTotalVolume();
        this.dataSource.data = this.list;
        this.dataSource.sort = this.sort;
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  loadSpecialtiesList() {
    this.labService.getSpecialtyList().subscribe(
      res => {
        this.specialties = res;
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  editLabSpecialty(specialty: ILabSpecialty) {
    this.editMode = 'edit';
    this.saveValue = specialty;
    let closeDate = specialty.dateClosed == null || specialty.dateClosed == '' ? ''
      : this.sharedService.getDate(specialty.dateClosed);
    this.specialtyFormGroup.patchValue({
      MajorCat: specialty.majorCat,
      Code: specialty.code,
      T_cd: specialty.t_CD,
      Pt: specialty.pt,
      Volume: specialty.volume,
      DateOpened: this.sharedService.getDate(specialty.dateOpened),
      DateClosed: closeDate,
      CreatedBy: specialty.createdBy,
      Comments: specialty.comments,
      LabId: specialty.labId,
      DateUpdated: specialty.dateUpdated,
      UpdatedBy: specialty.updatedBy,
      SpecialtyId: specialty.specialtyId
    });
    this.specialtyFormGroup.markAsPristine();
    this.specialtyFormGroup.controls['MajorCat'].disable({ onlySelf: true });
    this.specialtyFormGroup.controls['Code'].disable({ onlySelf: true });
    this.specialtyFormGroup.controls['T_cd'].disable({ onlySelf: true });
  }

  addLabSpecialty() {
    this.editMode = 'add';
    this.specialtyFormGroup.patchValue({
      MajorCat: '',
      Code: '',
      T_cd: '',
      Pt: '',
      Volume: 0,
      DateOpened: new Date(),
      DateClosed: '',
      CreatedBy: '',
      Comments: '',
      LabId: this.labService.lab.labId,
      DateUpdated: '',
      UpdatedBy: '',
      SpecialtyId: 0
    }
    );
    this.specialtyFormGroup.controls['MajorCat'].enable();
    this.specialtyFormGroup.controls['Code'].enable();
    this.specialtyFormGroup.controls['T_cd'].enable();
  }

  deleteLabSpecialty(id: number): void {
    id = id == 0 ? this.saveValue.specialtyId : id;
    if (!confirm('Delete this record? Continue?')) {
      return;
    }
    this.labService.deleteLabSpecialty(id.toString()).subscribe(
      () => {
      },
      error => console.log('error: ', error),
      () => {
        this.loadLabSpecialties();
      }
    );
    this.editMode = 'list';
  }

  saveLabSpecialty() {
    if (this.specialtyFormGroup.valid) {
      let form = this.specialtyFormGroup.getRawValue();
      let spec: ILabSpecialty = {
        majorCat: form.MajorCat,
        code: form.Code,
        t_CD: form.T_cd,
        pt: form.Pt,
        volume: +form.Volume,
        dateOpened: this.datePipe.transform(form.DateOpened, 'MM/dd/yyyy'),
        dateClosed: this.datePipe.transform(form.DateClosed, 'MM/dd/yyyy'),
        createdBy: form.CreatedBy,
        comments: form.Comments,
        labId: +form.LabId,
        dateUpdated: form.DateUpdated,
        updatedBy: form.UpdatedBy,
        specialtyId: +form.SpecialtyId
      };
      this.labService.saveLabSpecialty(spec).subscribe(
        () => {
          this.loadLabSpecialties();
        },
        error => console.log('error: ', error),
        () => {
        }
      );
      this.editMode = 'list';
    }
    else{
      if (!this.specialtyFormGroup.controls['DateOpened'].invalid){
        this.specialtyFormGroup.controls['DateOpened'].setValue("");
      }
    }
  }

  cancel() {
    if (this.specialtyFormGroup.dirty) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.editMode = 'list';
  }

  updateFields(value) {
    let item: ILabSpecialtyList;
    this.specialties.forEach(function (val: ILabSpecialtyList) {
      if (val.licAbbrev == value) {
        item = val;
      }
    });
    this.specialtyFormGroup.patchValue({
      MajorCat: item.majorCat,
      Code: item.licAbbrev,
      T_cd: item.t_CD,
      Pt: 'Y'
    });
  }

  calculateTotalVolume(){
    let volume = 0;
    this.list.forEach(function (val: ILabSpecialty) {
      volume += val.volume == null ? 0 : val.volume;
    });
    this.labService.totalVolume = volume;
  }

}